import styles from "./style.module.css"
import Typography from "../Typography/Typography"
import { useNavigate } from "react-router-dom";
import { getRelativeTime } from "../../utils/relativeTime";

interface Order {
    id: string;
    address: string;
    item: number;
    date: string;
    price: number;
    status: React.ReactNode;
    route?: string;
    onClick?: () => void
}

export const OrderList: React.FC<Order> = ({
    id,
    address,
    item,
    date,
    price,
    status,
    route,
    onClick,
}) => {

    const navigate = useNavigate()

    const routing = (id: string) => {
        if (route) {
            navigate(`${route}/${id}`)
        } else {
            return ""
        }
    }

    return (
        <div className={styles.container}
            onClick={() => {
                routing(id)
                if (onClick) {
                    return onClick()
                }
            }}
        >

            <div className={styles.leftHandSide}>

                <div>
                    <Typography
                        variant="heading6"
                        className={styles.idDate}
                    >
                        #{id} | {getRelativeTime(date)}
                    </Typography>
                </div>

                <div>
                    <Typography
                        variant="heading6"
                        className={styles.address}
                    >
                        {address}
                    </Typography>
                </div>

                <div>
                    <Typography>
                        Items: {item}
                    </Typography>
                </div>

            </div>

            <div className={styles.rightHandSide}>

                <div
                onClick={(e)=>{e.stopPropagation()}}
                >
                    {status}
                </div>

                <div className={styles.price}>
                    <Typography>
                        Price: ${price}
                    </Typography>
                </div>

            </div>

        </div>
    )
}